import React, { useState } from "react";
import { IonButton, IonCol, IonIcon, IonRow, IonSpinner } from "@ionic/react";
import { menuOutline, pencil, settingsOutline, trash } from "ionicons/icons";

import { iconsMenu } from "../Menu/IconData";

import "./ABMMenu.css";
import Modal from "../Modal/Modal";
import ApiRequestor from "../../api_access/ApiRequestor";
import { GetABMMenu } from "../../store/ABMMenu/ABMMenuActions";
import { connect } from "react-redux";

export interface Data {
    menuinfo_name: string;
    menuinfo_title: string;
    menuinfo_url: string;
    menuinfo_id: number;
    menuinfo_category: string[];
    menuinfo_order: number;
}

interface Props extends StateTypes, dispatchTypes {
    menuData: Data;
    index: number;
    dragListeners?: any;
    onModify: (data: Data) => void;
}

const ABMMenuTable: React.FC<Props> = (props) => {
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [showModalSuccessDelete, setShowModalSuccessDelete] = useState(false);
    const [showSipnner, setShowSpinner] = useState(false);
    const [isMounted, setIsMounted] = useState(true);

    const iconItem = iconsMenu.icons.find(
        (icon) => icon.title === props.menuData.menuinfo_name.toUpperCase()
    );

    const deleteItemMenu = async (id: any) => {
        setShowModalDelete(false);
        setShowSpinner(true);
        let data: any = {
            params: [id]
        }
        const response = await ApiRequestor.requestToApi('/swt-admin/menu-info', 'DELETE', data);
        if (isMounted && response && response.status === 200) {
            props.getABMMenu();
            setShowSpinner(false);
            setShowModalSuccessDelete(true);
        }
    }

    const deleteItemMenuModal = () => {
        setShowModalSuccessDelete(false);
    }

    return (
        <IonRow className="abmmenu-table-rows">
            <IonCol className="abmmenu-table-icon abmmenu-hiden" size="1">
                <IonIcon icon={menuOutline} style={{ cursor: 'grab' }} {...props.dragListeners} />
            </IonCol>

            <IonCol sizeXl="2" sizeXs="5">{props.menuData.menuinfo_title}</IonCol>
            <IonCol sizeXl="1" className="abmmenu-hiden">
                <IonIcon className="abmmenu-table-icon " icon={iconItem ? iconItem.iosIcon : settingsOutline} />
            </IonCol>
            <IonCol sizeXl="2" className="abmmenu-hiden">{props.menuData.menuinfo_url}</IonCol>
            <IonCol sizeXl="3" className="abmmenu-hiden">
                {props.menuData.menuinfo_category.join('-')}
            </IonCol>
            <IonCol size="1" className="abmmenu-hiden">{props.index + 1}</IonCol>
            <IonCol sizeXl="1" sizeXs="4">
                <IonButton type="button" fill="clear" onClick={() => props.onModify(props.menuData)}>
                    <IonIcon className="abmmenu-icon-add" icon={pencil} color="secondary" />
                </IonButton>
            </IonCol>

            <IonCol sizeXl="1" sizeXs="3">
                <IonButton type="button" fill="clear" onClick={() => setShowModalDelete(true)} id={props.menuData.menuinfo_id.toString()}>
                    <IonIcon className="abmmenu-icon-add" icon={trash} color="danger" />
                </IonButton>
            </IonCol>

            <Modal
                modalPrincipal={
                    {
                        textPrincipal: `¿Deseas eliminar el Item menú ${props.menuData.menuinfo_title}?`,
                        isOpen: showModalDelete,
                        onDidDismiss: () => setShowModalDelete(false),
                        onClick: () => deleteItemMenu(props.menuData.menuinfo_id),
                        onClickCloseModal: () => setShowModalDelete(false),
                        nameIcon: "warning",
                        colorIcon: "danger",

                    }
                }
                modalConfirmation={
                    {
                        isOpenModalConfirm: showModalSuccessDelete,
                        onDidDimissConfirmModal: () => deleteItemMenuModal(),
                        textConfirmation: "Item menú Eliminado con Éxito",
                        onClickConfirmModal: () => setShowModalSuccessDelete(false)

                    }
                }
            />
            {
                showSipnner &&
                <IonCol size="12" className="ion-padding">
                    <IonSpinner color="tertiary" name="lines" style={{ position: "fixed", top: "50%", left: "50%" }} />
                </IonCol>
            }
        </IonRow>
    );
};

interface StateTypes {
}

const mapStateToProps = (state: StateTypes) => {
    return {
    };
};

interface dispatchTypes {
    getABMMenu: () => void;
}

const mapDispatchToProps = (dispatch: any) => ({
    getABMMenu: () => dispatch(GetABMMenu())
});

export default connect(mapStateToProps, mapDispatchToProps)(ABMMenuTable);